import { gql } from '@apollo/client';

const listFeaturedJobs = gql`
  query ListFeaturedJobs(
    $pagination: PaginationInput
    $filters: [FilterInput!]
    $sort: SortInput
  ) {
    featuredJobs(pagination: $pagination, filters: $filters, sort: $sort) {
      data {
        id
        job {
          id
          title
          descriptionText
          coverImage
          liked
          accepted
          company {
            name
          }
          characteristicLabels {
            id
            name
          }
        }
      }
      pagination {
        total
      }
    }
  }
`;

// eslint-disable-next-line import/prefer-default-export
export { listFeaturedJobs };
